import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/store";
import { toast } from "sonner";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function Login() {
  const { loginLocal, registerLocal } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const googleLogin = () => {
    // Redirect to Emergent-managed Google Auth. Callback will land on /account with #session_id
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (mode === "login") {
        await loginLocal(email, password);
        toast.success("Bienvenido de vuelta");
      } else {
        await registerLocal(email, password, name);
        toast.success("Cuenta creada");
      }
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error de autenticación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] grid md:grid-cols-2">
      <div className="hidden md:block bg-navy relative">
        <img src="https://images.unsplash.com/photo-1523293182086-7651a899d37f?auto=format&fit=crop&q=85&w=1600" alt="" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        <div className="absolute bottom-12 left-12 text-white">
          <div className="font-mono-caps text-gold mb-3">Boutique</div>
          <h2 className="font-serif text-5xl leading-tight">La firma es<br /><span className="italic">personal.</span></h2>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <h1 className="font-serif text-4xl md:text-5xl" data-testid="auth-title">{mode === "login" ? "Bienvenido" : "Crea tu cuenta"}</h1>
          <p className="text-muted-foreground mt-2 text-sm">{mode === "login" ? "Accede a tu perfil y pedidos." : "Empieza a guardar tus favoritos y agiliza tus compras."}</p>

          <button
            onClick={googleLogin}
            className="w-full mt-8 border border-navy py-4 font-mono-caps hover:bg-navy hover:text-cream transition-colors"
            data-testid="google-login-btn"
          >
            Continuar con Google
          </button>

          <div className="flex items-center gap-4 my-6 text-xs text-muted-foreground">
            <div className="flex-1 h-px bg-border" />
            <span className="font-mono-caps">O con email</span>
            <div className="flex-1 h-px bg-border" />
          </div>

          <form onSubmit={submit} className="space-y-4" data-testid="auth-form">
            {mode === "register" && (
              <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Tu nombre" className="w-full border border-border p-4 focus:border-navy outline-none" data-testid="auth-name" />
            )}
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full border border-border p-4 focus:border-navy outline-none" data-testid="auth-email" />
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Contraseña" minLength={6} className="w-full border border-border p-4 focus:border-navy outline-none" data-testid="auth-password" />
            <button type="submit" disabled={loading} className="w-full bg-navy text-cream py-4 font-mono-caps hover:bg-cream hover:text-navy transition-colors" data-testid="auth-submit">
              {loading ? "…" : mode === "login" ? "Iniciar sesión" : "Crear cuenta"}
            </button>
          </form>

          <div className="text-sm text-muted-foreground mt-6 text-center">
            {mode === "login" ? "¿Nuevo aquí?" : "¿Ya tienes cuenta?"}{" "}
            <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="editorial-link text-foreground" data-testid="auth-toggle">
              {mode === "login" ? "Crea una cuenta" : "Inicia sesión"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
